import { Org } from './org';

export interface CapitalProvider extends Org {
  capitalProviderData: CapitalProviderData;
}

export interface CapitalProviderData {
  primaryType: string;
  aum: number;
  description: string;
  team: CapitalTeamMember[];
  targetedIndustries: string[];
  portfolioCompanies: CapitalPortfolioCompany[];
  financingTypes: string[];
  revenue: { min: number };
  checkSize: {
    min: number;
    max: number;
  };
  EBITDASize: { min: number };
}

export interface CapitalTeamMember {
  firstName: string;
  lastName: string;
  title: string;
}

export interface CapitalPortfolioCompany {
  name: string;
  naics: string[];
  website: string;
}
